import {call, delay, put, select, takeEvery, takeLeading} from 'redux-saga/effects'

import * as helloBarSelectors from '../store/helloBar'
import {
  ACTIVATE_HELLO_BAR,
  CLOSE_HELLO_BAR,
  DEACTIVATE_HELLO_BAR,
  OPEN_HELLO_BAR,
  closeHelloBar,
  openHelloBar,
} from '../actions/helloBar'
import {addGlobalHtmlClass, removeGlobalHtmlClass} from '../utils'

const IS_HELLO_BAR_OPEN = 'is--hello-bar-open'
const IS_HELLO_BAR_ACTIVE = 'is--hello-bar-active'

// Open/Close
// ----------------------------------------------------------------------------

export function* openHelloBarWorker() {
  yield call(addGlobalHtmlClass, IS_HELLO_BAR_OPEN)
}

export function* openHelloBarSaga() {
  yield takeEvery(OPEN_HELLO_BAR, openHelloBarWorker)
}

export function* closeHelloBarWorker() {
  yield call(removeGlobalHtmlClass, IS_HELLO_BAR_OPEN)
}

export function* closeHelloBarSaga() {
  yield takeEvery(CLOSE_HELLO_BAR, closeHelloBarWorker)
}

// Activate/Deactivate
// ----------------------------------------------------------------------------

export function* activateHelloBarWorker() {
  const delayTime = yield select(helloBarSelectors.delay)
  if (delayTime) {
    yield delay(delayTime)
  }

  yield put(openHelloBar())
  yield call(addGlobalHtmlClass, IS_HELLO_BAR_ACTIVE)
}

export function* activateHelloBarSaga() {
  yield takeLeading(ACTIVATE_HELLO_BAR, activateHelloBarWorker)
}

export function* deactivateHelloBarWorker() {
  yield put(closeHelloBar())
  yield call(removeGlobalHtmlClass, IS_HELLO_BAR_ACTIVE)
}

export function* deactivateHelloBarSaga() {
  yield takeEvery(DEACTIVATE_HELLO_BAR, deactivateHelloBarWorker)
}
